import { useRef } from "react";
import { Card } from "reshaped";

import BriefEditor from "../../brief/BriefEditor";
import type { Brief } from "../../brief/schema";
import { Field } from "./Field";
import {
    type AnyFieldProps,
    useFieldDirtyness,
    useFieldId,
    useFieldImperativeHandle,
    useValidity,
} from "./utilities";

const EMPTY_BRIEF: Brief = { blocks: [] };

export type BriefFieldProps = AnyFieldProps<Brief> & {};

export default function BriefField(props: BriefFieldProps) {
    const { value, onChange } = props;
    const id = useFieldId(props);
    const inputRef = useRef<HTMLInputElement>(null);

    const { isDirty, setDirty } = useFieldDirtyness(props);

    // const [search, setSearch] = useState<string>("");

    const validity = useValidity(props, []);

    // const onItemSelect = (item: T) => {
    //     setDirty();
    //     onChange(item);
    //     setSearch("");
    // };

    useFieldImperativeHandle(props, { validity, setDirty, inputRef });

    return (
        <Field {...props} isDirty={isDirty} validity={validity}>
            <Card>
                <BriefEditor value={value ?? EMPTY_BRIEF} onChange={onChange} />
            </Card>
        </Field>
    );
}
